import './SearchResultTable.css';
import React, { Component } from 'react';
import { InputNumber, Popover, Table } from 'antd';

export default class SearchResultTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: null,
      data: null
    };

    this.updateColumns = this.updateColumns.bind(this);
    this.updateData = this.updateData.bind(this);

    this.onProductsSelection = this.onProductsSelection.bind(this);
  }

  componentDidMount() {
    this.setState({ columns: null, data: null }, function() {
      this.updateColumns(this.props.data.columns);
      this.updateData(this.props.data.products);
    });
  }

  updateColumns(columns) {
    // setup some extra column values (rendering, height)
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      column.height = 48;

      if (column.columnType === 'IdentNr') {
        column.sorter = (a, b) => a.identNumber.localeCompare(b.identNumber);
        column.defaultSortOrder = 'ascend';
      } else if (column.columnType === 'SelectionCount') {
        column.fixed = 'left';
        column.render = (text, record) => (
          <InputNumber
            readOnly={this.props.readOnly ? true : false}
            min={0}
            defaultValue={text ? text : 0}
            onChange={value => this.onProductsSelection(record, value)}
          />
        );
      } else if (column.columnType === 'Image') {
        column.render = (text, record) => (
          <Popover
            content={
              <a href={text} target="_blank">
                <img
                  alt="preview"
                  style={{ minWidth: 200, maxWidth: 200, width: 200 }}
                  width="200"
                  src={text}
                />
              </a>
            }
          >
            <img
              alt="preview"
              height="44px"
              width="44px"
              style={{
                minHeight: 44,
                minWidth: 44,
                maxHeight: 44,
                maxWidth: 44
              }}
              src={text}
            />
          </Popover>
        );
      }
    }

    this.setState({ columns: columns });
  }

  updateData(products) {
    // we receive product data as array --> transform to object with params
    var rows = [];
    for (var i = 0; i < products.length; i++) {
      var product = products[i];

      var row = {};
      row.key = product.key;
      for (var y = 0; y < product.properties.length; y++) {
        var property = product.properties[y];
        row[property.name] = property.value;
      }
      rows.push(row);
    }
    this.setState({ data: rows });
  }

  onProductsSelection(product, value) {
    var selection = {};
    selection.key = product.key;
    selection.value = value;
    this.props.onProductsSelection(selection);
  }

  render() {
    const { columns } = this.state;
    return (
      <div className="col-12 col-sm-12 forced-scrollbar">
        <h4 className="text-brand">{this.props.data.categoryName}</h4>
        <div className="divider" />

        {this.state.columns && this.state.data ? (
          <Table
            rowKey="key"
            scroll={{ x: true }}
            pagination={false}
            columns={columns}
            dataSource={this.state.data}
            size="small"
          />
        ) : (
          <span />
        )}

        <div className="divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchResultTable.js